import service from '@/utils/server';

const modName='/md/customerGroup/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//查询详情
export const detailInfo = data => {
  return service({
    url: modName + 'customerGroupEdit/' + data.customerGroupId,
    method: 'post',
    data
  });
};

//编辑保存
export const submit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

export const deleteData = data => {
  return service({
    url: modName + 'delete/' + data.customerGroupId,
    method: 'post'
  });
};

//模板下载
export const downtemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//导入
export const uploadCustomerGroup = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadCustomerGroup',
    method: 'post',
    data
  });
};

//导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//批量删除
export const deleteBatchs = data => {
  console.log('-------', modName + 'deleteBatchs');
  return service({
    url: modName + 'deleteBatchSold',
    method: 'post',
    data
  })
};

//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/soldToGroup/api/index.js